import { Expose, Type } from '@nts/std/serialization';
import { UserLayoutColumnMetaData } from './user-layout-column-meta-data';
import { UserLayoutGridMetaDataInterface } from '@nts/std/interfaces';

export class UserLayoutGridMetaData implements UserLayoutGridMetaDataInterface {
    constructor() {
        this.customizedColumns = [];
    }

    @Expose()
    name: string;

    @Expose()
    path: string;

    private _fullPathName: string;

    @Expose()
    get fullPathName() {
        if (this._fullPathName?.length > 0) {
            return this._fullPathName;
        }
        let ret = this.path?.length > 0 ? `${this.path}.${this.name}` : this.name;
        ret = ret.replace(/.selectedItem/gi, '');
        return ret?.length > 0 ? ret : null;
    };
    set fullPathName(fullPathName: string) {
        this._fullPathName = fullPathName;
    }

    @Expose()
    @Type(() => UserLayoutColumnMetaData)
    customizedColumns: UserLayoutColumnMetaData[]
}
